
const setCompany = (state, company) => {
  state.company = company;
};

const setCompanyAdditionalChargesSetting = (state, additionalChargesSetting) => {
  state.company = {
    ...state.company,
    additionalChargesSetting,
  };
};

const setCompanyAdditionalChargesSettingEnabled = (state, additionalChargesSettingEnabled) => {
  state.company = {
    ...state.company,
    additionalChargesSetting: {
      ...state.company.additionalChargesSetting,
      enabled: additionalChargesSettingEnabled.value,
    },
  };
};

export default {
  setCompany,
  setCompanyAdditionalChargesSetting,
  setCompanyAdditionalChargesSettingEnabled,
};
